const state = () => ({
  audit:null,
  questionlist:null,
  questionlist_options:null,
  questionlist_columns:null,
  activesection:null,
  display:"sections",
  audit_questions_data_renewed:true,
  listview_questionlist:[],
  listview_preparing:false,
  selected_options:[],
  missing_attribute:false,
});
const getters = {
  audit(state){
    return state.audit
  },
  questionlist(state){
    return state.questionlist
  },
  questionlist_options(state){
    return state.questionlist_options
  },
  questionlist_columns(state){
    return state.questionlist_columns
  },
  activesection(state){
    return state.activesection
  },
  display(state){
    return state.display
  },
  audit_questions_data_renewed(state){
    return state.audit_questions_data_renewed
  },
  listview_questionlist(state){
    return state.listview_questionlist
  },
  listview_preparing(state){
    return state.listview_preparing
  },
  selected_options(state){
    return state.selected_options
  },
  missing_attribute(state){
    return state.missing_attribute
  },
};
const  mutations =  {
  SET_AUDIT(state,data){
    state.audit = data
  },
  SET_QUESTIONLIST(state,data){
    state.questionlist = data
  },
  SET_QUESTIONLIST_OPTIONS(state,data){
    state.questionlist_options = data
  },
  SET_QUESTIONLIST_COLUMNS(state,data){
    state.questionlist_columns = data
  },
  SET_ACTIVE_SECTION(state,data){
    state.activesection = data
  },
  SET_DISPLAY(state,data){
    state.display = data
  },
  SET_AUDIT_QUESTIONS_DATA_RENEWED(state,data){
    state.audit_questions_data_renewed = data
  },
  SET_LISTVIEW_QUESTIONLIST(state,data){
    state.listview_questionlist = data
  },
  SET_LISTVIEW_PREPARING(state,data){
    state.listview_preparing = data
  },
  SET_SELECTED_OPTIONS(state,data){
    state.selected_options = data
  },
  SET_MISSING_ATTRIBUTE(state,data){
    state.missing_attribute = data
  },
};
const actions =  {
  setAudit({commit},data)  {
    commit("SET_AUDIT",data)
  },
  setQuestionlist({commit},data)  {
    commit("SET_QUESTIONLIST",data)
  },
  setQuestionlistOptions({commit},data)  {
    commit("SET_QUESTIONLIST_OPTIONS",data)
  },
  setQuestionlistColumns({commit},data)  {
    commit("SET_QUESTIONLIST_COLUMNS",data)
  },
  setActiveSection({commit},data)  {
    commit("SET_ACTIVE_SECTION",data)
  },
  setDisplay({commit},data)  {
    commit("SET_DISPLAY",data)
  },
  setAuditQuestionsDataRenewed({commit},data)  {
    commit("SET_AUDIT_QUESTIONS_DATA_RENEWED",data)
  },
  setListviewQuestionlist({commit},data)  {
    commit("SET_LISTVIEW_QUESTIONLIST",data)
  },
  setListviewPreparing({commit},data)  {
    commit("SET_LISTVIEW_PREPARING",data)
  },
  setSelectedOptions({commit},data)  {
    commit("SET_SELECTED_OPTIONS",data)
  },
  setMissingAttribute({commit},data)  {
    commit("SET_MISSING_ATTRIBUTE",data)
  },
}

export default {
  namespaced: true,
  mutations,
  getters,
  state,
  actions,
};

